import { lazy } from 'react';

export const componentsMapper = {
  BannerV2: lazy(() => import('./Banner')),
  CarrosselV2: lazy(() => import('./Carousel')),
  CarrosselV2WithTitle: lazy(() => import('./Carousel')),
  CompoundSectionV2: lazy(() => import('./CompoundSection')),
  DividerV2: lazy(() => import('./Divider')),
  DividerV2KeyTitle: lazy(() => import('./Divider')),
  TextBlockV2: lazy(() => import('./TextBlock')),
  VideoV2: lazy(() => import('./Video')),
};
